import type { User } from 'next-auth';
import messageChannelStore from '@/src/stores/messageChannelStore';
import walletMessageChannel from '../walletMessageChannel';

type ConnectRequestOptions = {
  remainOpen?: boolean;
};

export type ConnectRequestHandler = (
  openerUrl: string,
  options?: ConnectRequestOptions
) => Promise<User>;

export const onConnectRequest: ConnectRequestHandler = (
  openerUrl: string,
  options?: ConnectRequestOptions
) => {
  return new Promise((resolve, reject) => {
    messageChannelStore.getState().setOpenerUrl(openerUrl);
    messageChannelStore.getState().setRemainOpen(options?.remainOpen ?? false);
    walletMessageChannel.connectionResolve = resolve;
    walletMessageChannel.connectionReject = reject;
  });
};
